import React from 'react';
import './Content.scss';

export const Content = () => {
  return (
    <div className="content-container">
      <h1 className="content-title">The standard Lorem Ipsum passage, used since the 1500s</h1>
      <p className="content-paragraph">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
      </p>
    </div>
  );
};
